import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { getActionsFromMenuLinks, MENU_LINKS } from '../../../hooks/useMenuItems';
import { UserRole } from '../../../types/UserRole';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';
import { mutationKeys } from '../mutationKeys';

export const updateUserRole = async (uuid: string, formData: UserRole) => {
  const response = await CustomAxios.put(`user_roles/${uuid}`, formData);
  const { data } = response;
  return data;
};
interface UseUpdateUserRoleFormProps {
  uuid: string;
  onSuccessCallback: () => void;
}
export function useUpdateUserRole({ uuid, onSuccessCallback }: UseUpdateUserRoleFormProps) {
  return useMutation({
    mutationKey: [mutationKeys.updateUserRole],
    mutationFn: (formData: UserRole) => updateUserRole(uuid, formData),
    onSuccess: (data: UserRole) => {
      // fetch the userRole again after create
      queryClient.invalidateQueries({ queryKey: [queryKeys.allUserRoles, data.uuid] });

      // fetch all actions again after
      queryClient.invalidateQueries({ queryKey: [queryKeys.allActions, getActionsFromMenuLinks(MENU_LINKS)] });

      // call success
      onSuccessCallback();
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 400) {
        const userRole: UserRole = err.response.data as UserRole;
        queryClient.setQueryData([queryKeys.allUserRoles, userRole.uuid], userRole);
      }
    },
  });
}
